import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON } from './constants';
import theme from './theme';
import sx from './sx';
function Octicon(_ref) {
  let {
    icon: IconComponent,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(IconComponent, rest);
}
Octicon.displayName = "Octicon";
const StyledOcticon = styled(Octicon).withConfig({
  displayName: "StyledOcticon",
  componentId: "uhnt7w-0"
})(["", " ", ""], COMMON, sx);
StyledOcticon.defaultProps = {
  theme,
  size: 16
};
StyledOcticon.propTypes = {
  ...COMMON.propTypes,
  ...sx.propTypes,
  icon: PropTypes.any.isRequired,
  size: PropTypes.any,
  theme: PropTypes.object,
  verticalAlign: PropTypes.oneOf(['middle', 'text-bottom', 'text-top', 'top'])
};
export default StyledOcticon;